import { ReactNode } from 'react';
import { Editor, Node } from '@sagold/react-json-editor';

import { Button } from '../../../components/buttons/Button';
import { GoogleFontIcon } from '../../../components/icons/GoogleFontIcon';
import { Popover } from '../../../components/popover/Popover';

export type Action = {
  icon: string;
  label?: string;
  enabled?: boolean;
  action: () => void;
};

type ArrayActionsProps = {
  editor: Editor;
  node: Node;
  options: {
    isOptional?: boolean;
    disabled?: boolean;
  };
  actions: ReactNode[];
};

export function ArrayWidgetActions({
  editor,
  node,
  options,
  actions,
}: ArrayActionsProps) {
  if (options.disabled) {
    return;
  }
  const { isOptional } = options;
  const listOfActions: React.ReactNode[] = [];
  if (isOptional) {
    listOfActions.push(
      <Button
        key="delete"
        variant="text"
        icon={<GoogleFontIcon name="delete" />}
        onClick={() => editor.removeValue(node.pointer)}
      >
        Remove Array
      </Button>
    );
  }
  listOfActions.push(...actions);
  if (listOfActions.length === 0) {
    return;
  }
  return (
    <div>
      <Popover
        content={<div className="rje-widget-actions">{listOfActions}</div>}
      >
        <Button
          variant="text"
          className="rje-widget-action rje-widget-action--menu"
        >
          <GoogleFontIcon name="menu" />
        </Button>
      </Popover>
    </div>
  );
}
